






































































import ThemeBlock from "@base/Components/theme/ThemeBlock.vue";
import SharingButtons from "@tool/Components/SharingButtons.vue";
import BuilderSectionOptionsSettingsModal from "@tool/Builder/sections/BuilderSectionOptionsSettingsModal.vue";


import {computed, defineComponent} from "@vue/composition-api";
import useBuilderStore from "@tool/store/useBuilderStore";
import useAppStore from "@tool/store/useAppStore";

export default defineComponent({
    components: {
        ThemeBlock,
        SharingButtons,
        BuilderSectionOptionsSettingsModal
    },
    setup() {

        const {showModalSettings, project} = useBuilderStore();

        const bookmarkInstructions = computed(() => {
            return 'Press <b>' + (/Mac/i.test(navigator.userAgent) ? 'Cmd' : 'Ctrl') + '+D</b> to bookmark this page.';
        });

        const isGuest = computed(() => {
            return project.value === null;
        });

        return {
            showModalSettings,
            bookmarkInstructions,
            isGuest,
        }
    }
});
